import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row align-items-center d-flex" }
const _hoisted_2 = { class: "col-12 col-md-6" }
const _hoisted_3 = { class: "col-12 col-md-6" }
const _hoisted_4 = { class: "form-check form-switch mt-1 mb-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label text-muted small mb-0",
  for: "register-foreigner-switch"
}, "Resido fora do Brasil", -1)
const _hoisted_6 = {
  key: 0,
  id: "error-msg-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TextInput, {
        required: true,
        id: "register-document",
        label: "Documento",
        maxLength: 30,
        model: _ctx.v$.documentNumber,
        type: "text",
        placeholder: _ctx.foreignDocument ? 'Informe o número do documento' : 'Informe o CPF',
        errorMsg: _ctx.errorMessage,
        mask: '************************'
      }, null, 8, ["model", "placeholder", "errorMsg"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.foreignDocument) = $event)),
          type: "checkbox",
          id: "register-foreigner-switch"
        }, null, 512), [
          [_vModelCheckbox, _ctx.foreignDocument]
        ]),
        _hoisted_5
      ])
    ]),
    (_ctx.v$.documentNumber.$invalid)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6))
      : _createCommentVNode("", true)
  ]))
}